<template>
  <el-card shadow="never" :body-style="{ padding: '0px' }">
    <div slot="header" class="toolbar">
      <h1>客户用户</h1>
      <el-link
        v-action="'/api/System/Customer/Binding'"
        type="primary"
        icon="el-icon-circle-plus"
        @click="onBinding()"
      />
    </div>
    <el-scrollbar>
      <ul>
        <li v-for="item in users" :key="item.UserId">
          <el-link
            v-action="'/api/System/Customer/Unbound'"
            type="danger"
            icon="el-icon-delete"
            @click="onUnbound(item)"
          />
          <label style="flex: 1">{{ item.Name }}_{{ item.Phone }}</label>
          <label>{{ item.Account }}</label>
        </li>
      </ul>
    </el-scrollbar>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      phone: null,
      users: [],
    };
  },
  props: {
    customer: { type: String, require: true },
  },
  created() {
    this.loadData();
  },
  methods: {
    //获取账户列表
    loadData() {
      this.$apis.organize.customer.user
        .list({
          customer: this.customer,
        })
        .then((res) => {
          this.users = res.Items.map((x) => x.User);
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    //绑定
    onBinding() {
      this.$prompt("通过系统用户手机号查询关联到客户单位", "关联用户", {
        center: true,
      }).then(({ value }) => {
        this.$apis.organize.customer.user
          .insert({
            phone: value,
            customer: this.customer,
          })
          .then(() => {
            this.loadData();
          })
          .catch((e) => {
            this.$message.error(e);
          });
      });
    },
    //解绑
    onUnbound(row) {
      this.$confirm(
        "此操作将永久删除数据不可恢复, 是否继续?",
        `删除 ${row.Name}`,
        {
          center: true,
        }
      ).then(() => {
        this.$apis.organize.customer.user
          .delete({
            userId: row.Id,
          })
          .then(() => {
            this.loadData();
          })
          .catch((e) => {
            this.$message.error(e);
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  padding: 10px;
  li {
    list-style: none;
    display: flex;
    align-items: center;
    padding: 10px;
    .el-link {
      font-size: 16px;
      margin-right: 10px;
    }
  }
}
</style>